export default __webpack_public_path__ + "static/media/viz_05.2141d424.mp4";